import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { MAX_USERNAME_LENGTH } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { PageStyles } from './NameScreen.styles';

export const NameScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Name',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();
  const form = useFormContext<LayoutDataType>();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formName = form.watch('name');
  const disableNextStep = !formName;

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = (): void => {
    if (!formName) return;

    userService
      .createOrUpdate({
        name: formName,
      })
      .then(() => {
        refreshUser();
      });

    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/name/background.jpg`}
          alt="AI Character"
        />
      }
      background="dark-solid"
    >
      <IonContent>
        <UiTypography className="name-title">
          Please, remind me your name
        </UiTypography>

        <div className="name-input-container">
          <FormInput
            form={form}
            hidden={false}
            disableButton={disableNextStep}
            onSubmit={handleNextStep}
            ref={inputRef}
            name="name"
            placeholder="Type your name"
            type="text"
            maxLength={MAX_USERNAME_LENGTH}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
